import api from "./ApiCentralAjuda";

const TicketMotivo = {
    index: () => {
        return api.get("/ticket/motivos");
    },
};

export default TicketMotivo;
